import NetworksIcon from './NetworksIcon'

export default NetworksIcon
